import API from 'services/API';
import { formatAddress } from 'utils';

export default function getContacts() {
  return API.request({
    method: 'GET',
    url: '/taxAuthoritiesContacts',
    mapper: function (data = []) {
      return data
        .map((taxAuthority) => {
          taxAuthority.address = formatAddress(taxAuthority.fnsAddress);
          return taxAuthority;
        })
        .sort((t1, t2) => {
          return t1.type - t2.type;
        });
    },
  });
}

export function getTaxAuthoritiesSuccessors() {
  return API.request({
    method: 'GET',
    url: '/taxAuthoritiesSuccessors',
  });
}
